import chatbotRequest from '@/service/channel/http'
import type { RoomListReq, RoomListRes } from '../type/getRoomList'

export function getRoomListApi(data: RoomListReq): Promise<RoomListRes> {
    return chatbotRequest<RoomListRes, RoomListReq, RoomListRes>({
        url: '/api/room/list',
        method: 'post',
        data,
    })
}
